<template>
    <div class="space-y-2 md:pl-6">
        <div class="relative md:-ml-3">
            <div
                class="absolute inset-0 flex items-center"
                aria-hidden="true"
            >
                <div class="w-full border-t border-gray-300" />
            </div>
            <div class="relative flex justify-start pl-6">
                <span
                    class="bg-white px-3 text-lg font-medium leading-6 text-gray-900"
                >
                    <span
                        v-if="question.required"
                        class="text-red-600"
                    >
                        *
                    </span>
                    {{ question.planQuestion.questionTitle }}
                </span>
            </div>
        </div>

        <content-reset :body="question.planQuestion.questionBody" />

        <plan-question-input
            :question="question"
            :billing-interval="billingInterval"
            :show-invalid-questions="showInvalidQuestions"
            @update:value="handleInputUpdate"
            @update-pricing="$emit('updatePricing')"
        />
    </div>
</template>

<script setup lang="ts">
import type {
    ContractQuestionFormData,
    QuestionValue
} from '~/composables/planQuestionFormData'
import PlanQuestionInput from '~/components/PurchaseContract/ParticipantDetails/PlanQuestions/PlanQuestionInput.vue'
import type { BillingInterval } from '~/resources/graphql/graphql'
import ContentReset from '~/components/ContentReset.vue'

const props = defineProps<{
    question: ContractQuestionFormData
    billingInterval: BillingInterval | null
    showInvalidQuestions: boolean
}>()

const emit = defineEmits<{
    (e: 'update:question', payload: ContractQuestionFormData): void
    (e: 'updatePricing'): void
}>()

function handleInputUpdate(value: QuestionValue) {
    emit('update:question', {
        ...props.question,
        propertyValue: value.propertyValue,
        planQuestionOptionIds: value.planQuestionOptionIds,
        invalid: value.invalid
    })
}
</script>
